/* Native details menus remain usable without JavaScript. */
(() => {
  'use strict';
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.tcs-header details[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const focused = document.activeElement;
    const menu = focused && focused.closest('.tcs-header details[open]');
    if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
    else document.querySelectorAll('.tcs-header details[open]').forEach((item) => { item.open = false; });
  });
  document.addEventListener('toggle', (event) => {
    const menu = event.target;
    if (!menu.matches('.tcs-nav-group') || !menu.open) return;
    const nav = menu.parentElement;
    nav.querySelectorAll(':scope > .tcs-nav-group[open]').forEach((sibling) => {
      if (sibling !== menu) sibling.open = false;
    });
  }, true);
})();

/* Collapse only the FAQ portion of long product descriptions. */
(() => {
  'use strict';

  const buildProductFaqs = () => {
    document.querySelectorAll('.tcs-product-description').forEach((description) => {
      if (description.dataset.tcsFaqReady === 'true') return;

      const faqHeading = Array.from(description.querySelectorAll('h2, h3')).find((heading) => /\bfaqs?\b/i.test(heading.textContent));
      if (!faqHeading) return;

      faqHeading.classList.add('tcs-product-faq-title');
      let node = faqHeading.nextElementSibling;
      let questionCount = 0;

      while (node) {
        if (node.matches('h2')) break;

        if (node.matches('h3, h4')) {
          const question = node;
          const nextQuestion = question.nextElementSibling;
          const details = document.createElement('details');
          const summary = document.createElement('summary');
          const answer = document.createElement('div');

          details.className = 'tcs-product-faq';
          summary.textContent = question.textContent.trim();
          answer.className = 'tcs-product-faq-answer';
          question.before(details);
          details.append(summary, answer);
          question.remove();

          let answerNode = nextQuestion;
          while (answerNode && !answerNode.matches('h2, h3, h4')) {
            const followingNode = answerNode.nextElementSibling;
            answer.append(answerNode);
            answerNode = followingNode;
          }

          questionCount += 1;
          node = answerNode;
          continue;
        }

        node = node.nextElementSibling;
      }

      if (questionCount) description.dataset.tcsFaqReady = 'true';
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', buildProductFaqs);
  else buildProductFaqs();
})();
